var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "red_alert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User-Management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-Locked(1)",
    transform: "translate(-310.000000, -127.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(294.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#AF365F",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0494205,11.5552158 L11.8766187,4.11043153 C11.9376084,3.5615247 11.5420733,3.06710591 10.9931665,3.00611627 C10.956497,3.00204188 10.9196301,3 10.882735,3 L9.11726502,3 C8.56498027,3 8.11726502,3.44771525 8.11726502,4 C8.11726502,4.03689515 8.11930689,4.07376203 8.12338128,4.11043153 L8.95057953,11.5552158 C8.97871468,11.8084321 9.19274679,12 9.4475214,12 L10.5524786,12 C10.8072532,12 11.0212853,11.8084321 11.0494205,11.5552158 Z M10.0073892,17 C10.4408867,17 10.7980296,16.8575269 11.0788177,16.5725806 C11.3596059,16.2876344 11.5,15.9354839 11.5,15.516129 C11.5,15.0860215 11.3596059,14.7258065 11.0788177,14.4354839 C10.7980296,14.1451613 10.4408867,14 10.0073892,14 C9.56403941,14 9.20197044,14.1451613 8.92118227,14.4354839 C8.64039409,14.7258065 8.5,15.0860215 8.5,15.516129 C8.5,15.9354839 8.64039409,16.2876344 8.92118227,16.5725806 C9.20197044,16.8575269 9.56403941,17 10.0073892,17 Z",
    id: "!",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlert);
export default __webpack_public_path__ + "static/media/red_alert.022411980a0bd718848078c60b54b8aa.svg";
export { ForwardRef as ReactComponent };